module.exports = __webpack_public_path__ + "img/bg-sd.5213e402.png";